import React from 'react';
import { Label } from '../../components/ui/label';

export function Box({ label, children }) {
  return (
    <div>
      <Label className="text-[10px] tracking-[0.15em] uppercase text-alp-gray mb-1.5 block">{label}</Label>
      {children}
    </div>
  );
}

export function Stat({ label, value, gold }) {
  return (
    <div className="border border-alp-line rounded p-4 bg-alp-card/40">
      <div className="text-[10px] tracking-[0.15em] uppercase text-alp-gray">{label}</div>
      <div className={`text-2xl font-serif mt-2 ${gold ? 'text-alp-gold' : 'text-alp-cream'}`}>{value}</div>
    </div>
  );
}
